/* ─── Ale · widget del storefront · comportamiento ────────────────────────────
   Cierra R4 (contexto de tienda), R5, R6 (sesión sin cookies) y R7.

   Se configura desde Liquid:
     window.CLX_ALE = { endpoint: 'https://…', pagina: 'producto', producto: '…' }

   Cero dependencias. Cero cookies: el id de sesión vive en localStorage y viaja
   en `X-Ale-Session`, porque una cookie del dominio del túnel sería third-party
   y Safari la bloquea — y mobile-first en WebKit no es negociable.
   ────────────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var cfg = window.CLX_ALE || {};
  if (!cfg.endpoint) return; // sin backend no se monta nada

  var LLAVE_SESION = 'clx_ale_sesion';
  var LLAVE_HILO = 'clx_ale_hilo';
  var LLAVE_PERSONA = 'clx_ale_persona';
  var LLAVE_PROACTIVA = 'clx_ale_proactiva'; // sessionStorage: 1 toque por sesión
  var MAX_TEXTO = 2000;

  // ─── Estado ───────────────────────────────────────────────────────────────
  var sesionId = null;
  var abierto = false;
  var enVuelo = false;
  var variante = null;
  var carrito = null;
  var persona = null;
  var el = {};
  var toqueNodo = null;      // el bocadillo de proactividad, si está en pantalla
  var toqueTimers = [];      // temporizadores del toque (para cancelarlos)

  // ─── Utilidades ───────────────────────────────────────────────────────────

  function crear(tag, clase, texto) {
    var n = document.createElement(tag);
    if (clase) n.className = clase;
    if (texto != null) n.textContent = texto;
    return n;
  }

  /** localStorage puede lanzar (modo privado de Safari, cuota). Nunca debe
   *  tumbar el widget: sin persistencia la sesión dura lo que la pestaña. */
  function guardar(llave, valor) {
    try { localStorage.setItem(llave, valor); } catch (e) { /* sin persistencia */ }
  }
  function leer(llave) {
    try { return localStorage.getItem(llave); } catch (e) { return null; }
  }

  // ─── Identidad · ambientación humana ────────────────────────────────────────
  // El motor responde SIEMPRE como "Ale" (respuestas.js). En el canal web la
  // atención se presenta con una asesora del equipo —a veces Ale, a veces otra—
  // para que la conversación se sienta personal y cálida. NO se afirma que sea una
  // persona humana: es la marca poniéndole nombre y cara a su atención (el estado
  // dice "en línea", presencia, no especie). La sustitución del nombre en las
  // burbujas es SOLO de presentación; el motor y lo que se manda al servidor
  // quedan intactos.

  // Mayoría mujeres, algunos hombres (dirección de Pedro). "Ale" va en la lista:
  // es la asesora insignia, no se reemplaza, solo se acompaña de su equipo. `t` =
  // tono del monograma (0-4), un matiz de la paleta para distinguir a dos asesoras.
  var PERSONAS = [
    { n: 'Ale', g: 'm', t: 0 }, { n: 'Regina', g: 'm', t: 1 }, { n: 'Valentina', g: 'm', t: 2 },
    { n: 'Marifer', g: 'm', t: 3 }, { n: 'Renata', g: 'm', t: 4 }, { n: 'Camila', g: 'm', t: 1 },
    { n: 'Ximena', g: 'm', t: 2 }, { n: 'Fernanda', g: 'm', t: 3 }, { n: 'Andrea', g: 'm', t: 4 },
    { n: 'Paulina', g: 'm', t: 0 }, { n: 'Diego', g: 'h', t: 2 }, { n: 'Emilio', g: 'h', t: 4 },
  ];

  function prefiereMenosMovimiento() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function elegirPersonaGuardada() {
    var crudo = leer(LLAVE_PERSONA);
    if (!crudo) return null;
    try {
      var p = JSON.parse(crudo);
      return (p && typeof p.nombre === 'string' && p.nombre) ? p : null;
    } catch (e) { return null; }
  }

  function nuevaPersona() {
    var base = PERSONAS[Math.floor(Math.random() * PERSONAS.length)];
    return { nombre: base.n, genero: base.g, tono: base.t };
  }

  /** Fija (y persiste) la asesora de esta clienta si aún no hay. Estable mientras
   *  viva su hilo: sus burbujas guardadas ya llevan el nombre, cambiarlo las
   *  contradiría. */
  function asegurarPersona() {
    if (persona) return persona;
    persona = elegirPersonaGuardada() || nuevaPersona();
    guardar(LLAVE_PERSONA, JSON.stringify(persona));
    return persona;
  }

  /** Reemplaza el auto-nombre del motor por la asesora en pantalla. Solo display.
   *  `\bAle\b` no pisa "Alejandra" ni "vale": exige límite de palabra a ambos lados. */
  function personalizar(texto) {
    if (!persona || !persona.nombre || persona.nombre === 'Ale') return texto;
    if (typeof texto !== 'string') return texto;
    return texto.replace(/\bAle\b/g, persona.nombre);
  }

  /** Avatar maison: monograma sobre disco de la paleta. Sin fotos —una cara de
   *  banco de imágenes de alguien que no existe sería más engañosa y obligaría a
   *  subir un asset al tema (el pipeline que ya costó 6 intentos). `null` = disco
   *  neutro para la fase "buscando". */
  function avatarNodo(p) {
    var d = crear('div', 'clx-ale-avatar');
    if (p && p.nombre) {
      d.textContent = p.nombre.charAt(0).toUpperCase();
      d.setAttribute('data-tono', String(p.tono != null ? p.tono : 0));
    } else {
      d.setAttribute('data-tono', 'busca');
    }
    d.setAttribute('aria-hidden', 'true');
    return d;
  }

  /** Sincroniza la cabecera (avatar + nombre + estado) con la asesora actual, o
   *  un neutro de marca si aún no se ha asignado. */
  function pintarIdentidad() {
    var nombre = (persona && persona.nombre) || 'Atención Shilex';
    var estado = persona
      ? ((persona.genero === 'h' ? 'Asesor' : 'Asesora') + ' · Shilex · en línea')
      : 'Shilex · en línea';
    if (el.nombre) el.nombre.textContent = nombre;
    if (el.estado) el.estado.textContent = estado;
    if (el.avatar) { el.avatar.innerHTML = ''; el.avatar.appendChild(avatarNodo(persona)); }
    if (el.panel) el.panel.setAttribute('aria-label', 'Chat de atención con ' + nombre);
  }

  /**
   * ⚠️ Copia LITERAL del selector de `clx-ale.css`. Si divergen, el CSS pinta
   * hoja inferior y el JS cree que es escritorio (o al revés) y se contradicen.
   *
   * La segunda condición existe porque un iPhone acostado mide 844×390: con solo
   * `max-width` pasaba por escritorio, le tocaba la tarjeta de esquina y el hilo
   * quedaba en 147px — y de paso se apagaba el seguimiento del teclado.
   */
  var MQ_MOVIL = '(max-width: 560px), (max-height: 480px) and (orientation: landscape)';

  /**
   * Filtro para todo lo que termine en un `href` o un `src`.
   *
   * Estas URLs las produce el LLM a partir del catálogo y viajan por
   * `localStorage`, que la clienta puede editar. El vector no es teórico: basta
   * una inyección en el texto del catálogo.
   *
   * Se filtran DOS cosas, y la segunda es la que faltaba:
   *   · el ESQUEMA — un `href` de `javascript:` se ejecuta EN EL DOMINIO DE LA
   *     TIENDA, con la sesión de Shopify de la clienta enfrente; y
   *   · el DESTINO — permitir `https://` a cualquier host dejaba abierto algo
   *     peor de ver: una tarjeta que dice "Ver en la tienda", con la interfaz de
   *     Shilex alrededor, abriendo un checkout falso. Eso no es XSS, es phishing
   *     con la confianza de la marca prestada.
   *
   * Lo que no pasa devuelve null y el nodo se pinta SIN enlace, no roto.
   */
  var HOSTS_PERMITIDOS = [
    'shilexmexico.com',
    'www.shilexmexico.com',
    'cdn.shopify.com',
    'wa.me',                 // el handoff a WhatsApp
    'api.whatsapp.com',
    'jtexpress.mx',          // rastreo J&T — el CTA "Ver rastreo" (respuestas.js:704)
    'www.jtexpress.mx',
  ];

  function hostPermitido(host) {
    if (host === window.location.hostname) return true;      // el propio storefront
    if (/(^|\.)myshopify\.com$/.test(host)) return true;      // dominio de la tienda y sus previsualizaciones
    return HOSTS_PERMITIDOS.indexOf(host) !== -1;
  }

  function urlSegura(crudo) {
    if (typeof crudo !== 'string') return null;
    var u = crudo.trim();
    if (!u) return null;
    try {
      // TODO pasa por el parser, incluidas las rutas relativas. La versión
      // anterior devolvía la ruta CRUDA sin revalidar si empezaba con `/`, y eso
      // era evadible: el parser normaliza `\` a `/` en esquemas especiales, así
      // que `/\evil.com/pago` pasaba el filtro y el navegador lo resolvía a
      // `http://evil.com/pago`. Lo mismo `//evil.com/pago`.
      var p = new URL(u, window.location.origin);
      if (p.protocol !== 'http:' && p.protocol !== 'https:') return null;
      // Credenciales embebidas: `https://tienda.com@evil.com` se lee como host
      // `evil.com`, y aunque el parser lo resuelve bien, mostrarlo es engañoso.
      if (p.username || p.password) return null;
      if (!hostPermitido(p.hostname)) return null;
      return p.href;
    } catch (e) {
      return null;
    }
  }

  function esEscritorio() {
    return !window.matchMedia(MQ_MOVIL).matches;
  }

  /**
   * Congela el fondo mientras el panel está abierto.
   *
   * Sin esto, el scroll del hilo "se contagia" a la página de atrás y en iOS
   * aparece el rebote elástico del storefront debajo del chat. Es buena parte
   * de la sensación de que algo está mal renderizado.
   */
  var scrollGuardado = 0;
  var fondoBloqueado = false;
  function bloquearFondo(activar) {
    var b = document.body;
    // En ESCRITORIO el panel es una tarjeta de esquina de 392px: congelar la
    // página entera dejaba a la clienta sin poder leer la ficha del producto
    // mientras le pregunta a Ale por ese mismo producto — que es literalmente
    // el caso de uso del canal. El bloqueo solo tiene sentido con la hoja
    // inferior, que sí tapa la página.
    if (activar && esEscritorio()) return;
    // Sin esta guarda, un segundo `abrir()` sin cerrar sobreescribía
    // `scrollGuardado` con 0 y la posición original se perdía para siempre.
    if (activar === fondoBloqueado) return;
    fondoBloqueado = activar;

    if (activar) {
      scrollGuardado = window.scrollY;
      b.style.position = 'fixed';
      b.style.top = -scrollGuardado + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
    } else {
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      b.style.width = '';
      window.scrollTo(0, scrollGuardado);
    }
  }

  /**
   * El aviso de envío gratis de la tienda (`clx-popup.js`) es de UNA VEZ POR
   * SESIÓN y se marca como visto en `sessionStorage` DENTRO de su `open()`,
   * ANTES de saber si alguien lo vio. Esconderlo con CSS —lo que se hacía
   * antes— no lo desarma: la bandera queda puesta y la oferta comercial más
   * importante de la tienda se pierde para el resto de la sesión, justo con las
   * clientas de mayor intención, que son las que abren el chat. Y peor: al
   * cerrar el chat, el velo ya tenía `is-on` y se estampaba de golpe en la cara.
   *
   * Aquí se hacen las dos cosas que faltaban:
   *   1. se cierra con SU PROPIO botón, para que corra su `close()` de verdad
   *      (limpia el `setInterval` de 1 s y el `keydown` que si no quedaban vivos); y
   *   2. se borra la bandera, para que el aviso salga en la siguiente página.
   *
   * No se toca `clx-popup.js`: es archivo del tema.
   */
  var vigilante = null;
  // Vigilar `attributes` en todo el subárbol del body dispara mucho (incluidas
  // las clases del propio widget). Sin esta guarda se encolarían decenas de
  // revisiones por segundo para una comprobación que casi siempre sale vacía.
  var revisionPendiente = false;

  function desarmarAvisoDeLaTienda() {
    var ov = document.querySelector('.clxpop-ov');
    if (!ov) return;
    // ⚠️ `is-on` es lo que distingue "se está mostrando" de "la clienta ya lo
    // cerró y está en los 420 ms que `clx-popup.js` tarda en sacarlo del DOM".
    // Sin esta guarda se le borraba la bandera a un aviso YA VISTO Y CERRADO, y
    // se lo volvían a estampar en la siguiente página: cerrar la oferta y tocar
    // el chat es un gesto de lo más natural.
    if (!ov.classList.contains('is-on')) return;
    var x = ov.querySelector('.clxpop__x');
    if (x) x.click();
    else ov.parentNode && ov.parentNode.removeChild(ov);
    // Si el aviso llegó a dispararse es porque la bandera NO estaba puesta (su
    // `open()` corta de entrada si lo está), así que borrarla lo devuelve al
    // estado exacto en que estaba.
    try { sessionStorage.removeItem('clxPopShown'); } catch (e) { /* modo privado */ }
  }

  function vigilarAvisoDeLaTienda(encender) {
    if (!encender) {
      if (vigilante) { vigilante.disconnect(); vigilante = null; }
      return;
    }
    if (vigilante || typeof MutationObserver === 'undefined') return;
    desarmarAvisoDeLaTienda(); // por si ya estaba puesto al abrir
    vigilante = new MutationObserver(function () {
      // `clx-popup.js` hace `appendChild` y recién en el `requestAnimationFrame`
      // siguiente pone `is-on`. El observador dispara con el appendChild, cuando
      // la clase todavía no está — así que se mira un par de fotogramas después,
      // que es cuando ya se puede distinguir un aviso que se abre de uno que se
      // está cerrando.
      if (!abierto || revisionPendiente) return;
      revisionPendiente = true;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          revisionPendiente = false;
          if (abierto) desarmarAvisoDeLaTienda();
        });
      });
    });
    // `childList` NO alcanza. Si `clx-popup.js` ya hizo su `appendChild` justo
    // antes de que la clienta tocara el lanzador, esa mutación ocurrió cuando el
    // observador todavía no existía: nunca la ve. Y el desarme síncrono de
    // arriba aborta porque `is-on` aún no está puesto (llega en el `rAF`
    // siguiente). Resultado: el aviso quedaba escondido por CSS con la bandera
    // puesta — exactamente lo que la guarda venía a evitar.
    // Vigilar también el atributo `class` atrapa el momento en que aparece
    // `is-on`, que es la señal que de verdad importa.
    vigilante.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  /**
   * El teclado de iOS NO encoge el viewport: se dibuja ENCIMA. Con el panel a
   * `100dvh`, el campo de escritura queda debajo del teclado y la clienta
   * escribe a ciegas. `visualViewport` es lo único que reporta el alto que de
   * verdad queda visible.
   */
  function seguirTeclado() {
    var vv = window.visualViewport;
    if (!vv) return;
    /**
     * Cuánto del viewport de layout tiene que desaparecer para creer que hay un
     * teclado. La barra de URL de iOS al recogerse mueve ~60px; un teclado
     * vertical, 300+. El umbral vive en medio, tirando a bajo, porque el error
     * caro es el falso NEGATIVO: si no se reacciona, la clienta escribe a
     * ciegas. ⚠️ Un teclado accesorio muy plano (barra de predicción con teclado
     * físico en iPad, ~90px) sigue quedando por debajo — es una limitación
     * conocida y NO verificada en hardware, no un caso resuelto.
     */
    var ALTO_TECLADO_MIN = 120;

    var soltar = function () {
      el.panel.style.height = '';
      el.panel.style.transform = '';
      // ⚠️ `data-compacto` se quedaba PEGADO: solo se limpiaba al final de
      // `ajustar()`, que es inalcanzable después de cualquiera de los dos
      // `return soltar()` de arriba. Resultado medido: bastaba escribir UNA vez
      // en horizontal para que el panel quedara estrecho el resto de la sesión
      // —sin subtítulo, sin asa, cabecera de 57px en vez de 76— incluso tras
      // cerrar el teclado y tras cerrar y reabrir el chat. Se limpia donde se
      // limpia todo lo demás.
      el.panel.removeAttribute('data-compacto');
    };

    var ajustar = function () {
      // ⚠️ Aquí había un `|| esEscritorio()` y era un error de clasificación, no
      // de umbral. TODO iPad cae en "escritorio" (810×1080 no matchea `MQ_MOVIL`),
      // así que en tablet el seguimiento del teclado estaba APAGADO: medido con
      // un teclado de 370px, el pie entero —campo y botón de enviar— quedaba
      // debajo de las teclas. Es exactamente el mismo defecto que se corrigió
      // para el celular acostado, dejado de pie en la otra punta.
      //
      // El teclado no es asunto del MODO de presentación: da igual si el panel
      // es hoja inferior o tarjeta de esquina, los dos están anclados abajo y
      // los dos quedan bajo las teclas. Lo único que cambia es cuánto alto se
      // les permite, y eso se resuelve más abajo.
      if (!abierto) return soltar();

      var alturaLayout = document.documentElement.clientHeight || window.innerHeight;
      // Lo que la barra de previsualización de Shopify ya se está comiendo por
      // abajo. En producción es 0 y todo lo de aquí queda igual que antes.
      var fondo = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--clx-ale-fondo')) || 0;
      var oculto = alturaLayout - vv.height - (vv.offsetTop || 0);

      // ⚠️ Antes esto fijaba `height = vv.height` SIN condición ni techo, y con
      // eso pisaba el `88dvh` del CSS: al primer evento —y en iOS uno llega
      // cada vez que se recoge la barra de URL al hacer scroll— la hoja
      // inferior se volvía pantalla completa. Es exactamente el "parece que el
      // storefront desapareció" que reportó Pedro y para el que existe el 88dvh.
      //
      // Y un pellizco para hacer zoom también encoge `vv.height` y levanta
      // `offsetTop` sin que haya ningún teclado: sin mirar `scale`, el panel se
      // desplazaba a ciegas.
      var conPellizco = (vv.scale || 1) > 1.01;
      if (conPellizco || oculto < ALTO_TECLADO_MIN) return soltar();

      // La animación de entrada tiene `fill-mode: both` y le gana al estilo en
      // línea; si el teclado ya estaba abierto, había una ventana de 360 ms en
      // que el `translateY` no surtía efecto. Se suelta aquí, en el momento en
      // que de verdad estorba.
      el.panel.removeAttribute('data-estado');

      // El `translateY` sube el panel para que su base coincida con el borde
      // superior del teclado: está anclado a `bottom:0` del viewport de LAYOUT,
      // que en iOS no se encoge, así que sin esto el campo de escritura queda
      // debajo de las teclas y la clienta escribe a ciegas.
      // Se descuenta `fondo` porque el panel YA está subido esa distancia por el
      // CSS: subirlo otra vez lo pasaría de largo.
      el.panel.style.transform = 'translateY(-' + Math.round(Math.max(0, oculto - fondo)) + 'px)';

      // ⚠️ Y el ALTO tiene que bajar con él. Al corregir el defecto anterior
      // (que fijaba el alto sin condición) borré esta línea, y el resultado fue
      // peor: el panel conservaba sus 88dvh mientras subía 336px, así que la
      // CABECERA SE SALÍA DE LA PANTALLA — con el botón de cerrar dentro. La
      // clienta quedaba sin forma de salir del chat salvo bajando el teclado a
      // ciegas. El alto nunca puede exceder lo que de verdad se ve.
      //
      // El techo depende del MODO, que es lo único que cambia entre los dos:
      //   · hoja inferior → pegada a `bottom:0`, puede usar todo lo visible;
      //   · tarjeta de esquina → vive a `--clx-ale-offset` del borde, así que
      //     hay que descontarlo (y un respiro) o se sale por abajo.
      var margen = esEscritorio() ? 28 : 0;
      var techoDelModo = esEscritorio() ? 600 : (alturaLayout * 0.88 - fondo);
      var disponible = Math.round(Math.min(vv.height - margen, techoDelModo));

      // ⚠️ Aquí había un piso de `Math.max(220, …)` y era la forma EQUIVOCADA de
      // resolverlo. En celular acostado con teclado quedan ~140-190px visibles;
      // forzar 220 empujaba el panel fuera de pantalla POR ARRIBA: la cabecera y
      // el botón de cerrar salían de la vista y, como el panel cubría toda la
      // franja, tampoco quedaba velo que tocar. La clienta quedaba ENCERRADA en
      // el chat, sin botón, sin "tocar fuera" y sin Escape.
      //
      // Y quitar el piso a secas tampoco servía: el cromo fijo del panel
      // (cabecera 76 + pie 68 + aire del hilo 36 ≈ 180px) NO CABE en 140. El
      // problema nunca fue el número, era que el panel no sabe encogerse.
      //
      // Por eso, cuando el espacio se aprieta de verdad, el panel entra en modo
      // COMPACTO: la cabecera pierde el subtítulo y el aire, el hilo pierde
      // relleno, y lo que queda protegido es lo único que no puede faltar —
      // el botón de CERRAR y el campo de escribir. El hilo se queda con lo que
      // sobre, aunque sea poco: se puede hacer scroll en él, pero no se puede
      // hacer scroll para encontrar una salida que está fuera de la pantalla.
      if (disponible < 260) el.panel.setAttribute('data-compacto', '1');
      else el.panel.removeAttribute('data-compacto');

      el.panel.style.height = disponible + 'px';
      alFinal();
    };
    vv.addEventListener('resize', ajustar);
    vv.addEventListener('scroll', ajustar);
  }

  // ─── Contexto de la tienda ────────────────────────────────────────────────

  /**
   * La variante se lee por ESTADO del DOM, no por evento: el tema no emite
   * ninguno al cambiar de tono. Se observa el selector con MutationObserver
   * sobre `aria-pressed` y sobre el input oculto que el tema mantiene.
   */
  function observarVariante() {
    var seleccionActual = function () {
      var presionado = document.querySelector('[data-clx-variante][aria-pressed="true"], .product-form__input input:checked + label, [name="id"]');
      if (!presionado) return null;
      var etiqueta =
        presionado.getAttribute('data-clx-variante') ||
        presionado.getAttribute('aria-label') ||
        (presionado.textContent || '').trim();
      return etiqueta || null;
    };

    variante = seleccionActual();

    var formulario = document.querySelector('form[action*="/cart/add"]');
    if (!formulario || typeof MutationObserver === 'undefined') return;

    var obs = new MutationObserver(function () {
      var nueva = seleccionActual();
      if (nueva && nueva !== variante) variante = nueva;
    });
    obs.observe(formulario, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-pressed', 'aria-checked', 'checked', 'value', 'class'],
    });
  }

  /** El carrito se lee del AJAX API del tema, que ya está disponible. */
  function refrescarCarrito() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items) return;
        carrito = c.items.slice(0, 10).map(function (i) {
          return { titulo: i.product_title, cantidad: i.quantity };
        });
      })
      .catch(function () { /* el contexto es una mejora, no un requisito */ });
  }

  function contexto() {
    var ctx = { pagina: cfg.pagina || 'otra' };
    if (cfg.producto) ctx.producto = cfg.producto;
    if (cfg.coleccion) ctx.coleccion = cfg.coleccion;
    if (cfg.precio) ctx.precio = cfg.precio;
    if (variante) ctx.variante = variante;
    if (carrito && carrito.length) ctx.carrito = carrito;
    return ctx;
  }

  // ─── Red ──────────────────────────────────────────────────────────────────

  function pedir(ruta, cuerpo) {
    var cabeceras = { 'Content-Type': 'application/json' };
    if (sesionId) cabeceras['X-Ale-Session'] = sesionId;

    return fetch(cfg.endpoint + ruta, {
      method: 'POST',
      headers: cabeceras,
      body: JSON.stringify(cuerpo || {}),
      // Sin cookies, a propósito: la sesión va por cabecera.
      credentials: 'omit',
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        return { ok: r.ok, status: r.status, datos: j };
      });
    });
  }

  function asegurarSesion() {
    if (sesionId) return Promise.resolve(sesionId);
    var guardada = leer(LLAVE_SESION);
    if (guardada) { sesionId = guardada; return Promise.resolve(sesionId); }

    return pedir('/sesion', { contexto: contexto() }).then(function (r) {
      if (!r.ok || !r.datos.sesionId) throw new Error('sesion');
      sesionId = r.datos.sesionId;
      guardar(LLAVE_SESION, sesionId);
      return sesionId;
    });
  }

  // ─── Pintado ──────────────────────────────────────────────────────────────

  function alFinal() {
    el.hilo.scrollTop = el.hilo.scrollHeight;
  }

  function burbuja(de, texto) {
    // Solo display: el nombre de la asesora sustituye el auto-nombre del motor.
    // Se anota el texto YA personalizado, así el hilo guardado es coherente con
    // la asesora y al restaurar no se vuelve a sustituir (idempotente).
    if (de === 'ale') texto = personalizar(texto);
    var b = crear('div', 'clx-ale-burbuja', texto);
    b.setAttribute('data-de', de);
    anotar({ tipo: 'burbuja', de: de, t: texto });
    el.hilo.appendChild(b);
    alFinal();
    return b;
  }

  function tarjeta(t) {
    anotar({ tipo: 'tarjeta', de: 'ale', datos: t });
    var enlace = urlSegura(t.url);
    var foto = urlSegura(t.foto);
    var caja = crear(enlace ? 'a' : 'div', 'clx-ale-tarjeta');
    if (enlace) { caja.href = enlace; caja.target = '_blank'; caja.rel = 'noopener'; }

    if (foto) {
      var img = crear('img');
      img.src = foto;
      img.alt = t.producto || '';
      img.loading = 'lazy';
      caja.appendChild(img);
    }
    var txt = crear('div');
    txt.appendChild(crear('div', 'clx-ale-tarjeta-nombre', t.producto || 'Producto'));
    if (t.url) txt.appendChild(crear('div', 'clx-ale-tarjeta-pie', 'Ver en la tienda'));
    caja.appendChild(txt);
    el.hilo.appendChild(caja);
    alFinal();
  }

  /**
   * #2 Descubrimiento: pinta las tarjetas de producto que el adaptador detectó
   * en lo que Ale dijo. Cada una lleva imagen, nombre, precio y un botón que
   * reusa `agregarAlCarrito` (el mismo camino AJAX de "Comprar ahora"). Un
   * producto agotado se pinta SIN botón, con la marca "Agotado" — el adaptador
   * ya lo trae con `agotado:true` desde el catálogo (R2). Los datos vienen del
   * catálogo, no del texto: aquí no se inventa nada.
   */
  function tarjetasProducto(lista) {
    if (!Array.isArray(lista) || !lista.length) return;
    anotar({ tipo: 'tarjetas', de: 'ale', datos: lista });
    var caja = crear('div', 'clx-ale-cards');
    lista.forEach(function (t) {
      if (!t || typeof t !== 'object' || !t.producto) return;
      var card = crear('div', 'clx-ale-card');

      var foto = urlSegura(t.imagen);
      if (foto) {
        var img = crear('img', 'clx-ale-card-img');
        img.src = foto;
        img.alt = t.producto;
        img.loading = 'lazy';
        card.appendChild(img);
      }

      var cuerpo = crear('div', 'clx-ale-card-cuerpo');
      cuerpo.appendChild(crear('div', 'clx-ale-card-nombre', t.producto));
      if (typeof t.precio === 'number') {
        cuerpo.appendChild(crear('div', 'clx-ale-card-precio', '$' + t.precio));
      }

      if (t.agotado) {
        cuerpo.appendChild(crear('span', 'clx-ale-card-agotado', 'Agotado'));
      } else if (t.handle || urlSegura(t.url)) {
        var b = crear('button', 'clx-ale-card-add', 'Agregar');
        b.type = 'button';
        b.setAttribute('data-tipo', 'card-add');
        b.addEventListener('click', function () {
          agregarAlCarrito({ payload: { handle: t.handle, url: t.url } });
        });
        cuerpo.appendChild(b);
      }

      card.appendChild(cuerpo);
      caja.appendChild(card);
    });
    if (!caja.childNodes.length) return; // nada pintable → no dejes una caja vacía
    el.hilo.appendChild(caja);
    alFinal();
  }

  function acciones(lista) {
    anotar({ tipo: 'acciones', de: 'ale', datos: lista });
    var caja = crear('div', 'clx-ale-acciones');

    lista.forEach(function (a) {
      if (!a || typeof a !== 'object') return;
      var esLink = a.tipo === 'link';
      var destino = esLink ? urlSegura(a.payload && a.payload.url) : null;
      // Un `link` cuya URL no pasa el filtro se degrada a botón inerte en vez de
      // pintarse como enlace roto.
      var n = crear(destino ? 'a' : 'button', 'clx-ale-accion', a.etiqueta);
      n.setAttribute('data-tipo', a.tipo);

      if (destino) {
        n.href = destino;
        n.target = '_blank';
        n.rel = 'noopener';
      } else if (a.tipo === 'atajo') {
        n.type = 'button';
        // Sin `payload.texto` esto lanzaba un TypeError al tocarlo y dejaba un
        // botón muerto en medio de la conversación.
        var texto = a.payload && a.payload.texto;
        if (!texto) return;
        n.addEventListener('click', function () {
          caja.remove();
          enviar(texto);
        });
      } else if (a.tipo === 'agregar') {
        n.type = 'button';
        n.addEventListener('click', function () { agregarAlCarrito(a); });
      } else if (a.tipo === 'tickets') {
        n.type = 'button';
        n.addEventListener('click', function () { abrirTickets(); });
      } else if (a.tipo === 'handoff') {
        n.type = 'button';
        n.addEventListener('click', function () { saltarAWhatsApp(a); });
      }
      caja.appendChild(n);
    });

    el.hilo.appendChild(caja);
    alFinal();
  }

  /**
   * El click se registra en el servidor ANTES del salto. Ésa es la correlación
   * robusta: el `ref` que va en el texto pre-llenado la clienta lo puede borrar,
   * y `ctwa_clid` no aplica a un `wa.me` genérico.
   *
   * La ventana se abre SIEMPRE, aunque el registro falle: perder una métrica es
   * barato, dejar a la clienta sin salida no.
   */
  function saltarAWhatsApp(accion) {
    var respaldo = urlSegura(accion.payload && accion.payload.url);
    // Safari bloquea `window.open` fuera del gesto del usuario, así que la
    // pestaña se abre YA y se le pone la URL cuando el servidor responde.
    var ventana = window.open('', '_blank');

    pedir('/handoff', { contexto: contexto() })
      .then(function (r) {
        var url = (r.ok && urlSegura(r.datos.url)) || respaldo;
        if (ventana) ventana.location = url;
        else if (url) window.location.href = url;
      })
      .catch(function () {
        if (ventana && respaldo) ventana.location = respaldo;
      });
  }

  /**
   * "Comprar ahora" en la tienda AGREGA al carrito de verdad. En WhatsApp el CTA
   * era una liga a la página del producto —lo único que Ale puede mandar allá—,
   * pero aquí la clienta YA está en el storefront, así que esa liga la mandaría a
   * donde ya está. Resuelve la variante SIN adivinar: si está viendo ese mismo
   * producto, su tono seleccionado manda; si sólo hay un tono disponible, ese; si
   * hay varios, PREGUNTA en el chat. Nunca aparta un tono equivocado. Cualquier
   * fallo cae al respaldo: abrir la página del producto (el comportamiento viejo).
   */
  function agregarAlCarrito(accion) {
    var pl = accion.payload || {};
    var respaldo = urlSegura(pl.url);
    var handle = pl.handle ||
      (respaldo && (respaldo.match(/\/products\/([^/?#]+)/) || [])[1]) || null;
    if (!handle) { if (respaldo) window.open(respaldo, '_blank', 'noopener'); return; }

    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('producto ' + r.status)); })
      .then(function (prod) {
        var disp = (prod.variants || []).filter(function (v) { return v.available; });
        if (!disp.length) {                 // agotado: que lo vea en la página del tema
          if (respaldo) window.open(respaldo, '_blank', 'noopener');
          return;
        }
        // ¿Está viendo ESTE producto? Entonces su selección de tono manda.
        var enPagina = cfg.pagina === 'producto' &&
          (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] === handle;
        var idPagina = enPagina &&
          (document.querySelector('form[action*="/cart/add"] [name="id"]') || {}).value;
        if (idPagina && disp.some(function (v) { return String(v.id) === String(idPagina); })) {
          return agregarVariante(idPagina, null);
        }
        if (disp.length === 1) return agregarVariante(disp[0].id, null);
        ofrecerTonos(disp);               // varios y no sabemos cuál → se pregunta
      })
      .catch(function () { if (respaldo) window.open(respaldo, '_blank', 'noopener'); });
  }

  /** Pregunta el tono en el chat cuando hay varios disponibles. Transitorio. */
  function ofrecerTonos(disp) {
    var q = crear('div', 'clx-ale-burbuja', '¿en qué tono te lo aparto? 💛');
    q.setAttribute('data-de', 'ale');
    el.hilo.appendChild(q);
    var caja = crear('div', 'clx-ale-acciones');
    disp.slice(0, 6).forEach(function (v) {
      var b = crear('button', 'clx-ale-accion', v.title);
      b.type = 'button';
      b.setAttribute('data-tipo', 'tono');
      b.addEventListener('click', function () {
        q.remove(); caja.remove();
        agregarVariante(v.id, v.title);
      });
      caja.appendChild(b);
    });
    el.hilo.appendChild(caja);
    alFinal();
  }

  /**
   * Agrega la variante por el AJAX del tema y abre su cajón de carrito
   * (`cart-drawer`, estilo Dawn: `getSectionsToRender` + `renderContents` +
   * `open`). Si el tema no expone el cajón, cae a la página `/cart`. La clienta
   * se queda en la tienda; no se la saca al checkout — decisión de Pedro.
   */
  function agregarVariante(id, tono) {
    var dr = document.querySelector('cart-drawer');
    var cuerpo = { id: Number(id), quantity: 1 };
    if (dr && typeof dr.getSectionsToRender === 'function') {
      try {
        cuerpo.sections = dr.getSectionsToRender().map(function (s) { return s.id; });
        cuerpo.sections_url = window.location.pathname;
      } catch (e) { /* sin sections el add igual funciona, sólo no refresca el cajón */ }
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(cuerpo),
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('add ' + r.status)); })
      .then(function (res) {
        refrescarCarrito();
        burbuja('ale', tono ? ('listo, te aparté el tono ' + tono + ' 💛')
                            : 'listo, te lo aparté en el carrito 💛');
        if (dr && typeof dr.renderContents === 'function') {
          try { dr.renderContents(res); } catch (e) { /* abajo se abre igual */ }
        }
        if (dr && typeof dr.open === 'function') { try { dr.open(); } catch (e) {} }
        else { window.location.href = '/cart'; }
      })
      .catch(function () {
        burbuja('ale', 'uy, no pude apartarlo — inténtalo otra vez, y si sigue igual escríbeme y lo vemos 💛');
      });
  }

  /**
   * "Tickets especializados": submenú del CANAL (no del motor). Cada tema entra
   * por el flujo de texto normal, así Ale responde en su tono; y si el caso
   * rebasa lo que sabe, el motor escala al equipo especializado (etiqueta
   * neutral, sin nombrar el canal). Transitorio: no se persiste en el hilo.
   */
  var TEMAS_TICKET = [
    { etiqueta: '📦 Rastrear mi pedido', texto: 'quiero rastrear mi pedido' },
    { etiqueta: '⚠️ Problema con mi pedido', texto: 'tengo un problema con mi pedido' },
    { etiqueta: '🔁 Cambios y devoluciones', texto: 'quiero información sobre cambios y devoluciones' },
  ];

  function abrirTickets() {
    var q = crear('div', 'clx-ale-burbuja', '¿con qué te ayudo? 🎫');
    q.setAttribute('data-de', 'ale');
    el.hilo.appendChild(q);
    var caja = crear('div', 'clx-ale-acciones');
    TEMAS_TICKET.forEach(function (tema) {
      var b = crear('button', 'clx-ale-accion', tema.etiqueta);
      b.type = 'button';
      b.setAttribute('data-tipo', 'ticket-tema');
      b.addEventListener('click', function () {
        q.remove();
        caja.remove();
        enviar(tema.texto);
      });
      caja.appendChild(b);
    });
    el.hilo.appendChild(caja);
    alFinal();
  }

  function pensando(encender) {
    if (encender) {
      if (document.getElementById('clx-ale-pensando')) return;
      var p = crear('div', 'clx-ale-pensando');
      p.id = 'clx-ale-pensando';
      p.setAttribute('aria-hidden', 'true'); // el texto real lo anuncia aria-live
      var quien = (persona && persona.nombre) || 'Ale';
      p.appendChild(crear('span', 'clx-ale-pensando-quien', quien + ' está escribiendo'));
      var pts = crear('span', 'clx-ale-pensando-pts');
      pts.innerHTML = '<i></i><i></i><i></i>';
      p.appendChild(pts);
      el.hilo.appendChild(p);
      alFinal();
    } else {
      var v = document.getElementById('clx-ale-pensando');
      if (v) v.remove();
    }
  }

  // ─── Ritual de conexión (ambientación humana, 1ª vez por sesión) ────────────
  // Teatro de "te estamos consiguiendo a alguien del equipo". Front-end puro,
  // DESACOPLADO de la red (la lección del V1: nunca atar el teatro a la latencia
  // del LLM). El saludo real se pinta cuando se cumplen el mínimo de teatro Y la
  // respuesta del motor, lo que ocurra al último.
  var ritualNodo = null;
  var ritualVisualTimers = [];

  function quitarRitual() {
    ritualVisualTimers.forEach(function (t) { clearInterval(t); clearTimeout(t); });
    ritualVisualTimers = [];
    if (ritualNodo && ritualNodo.parentNode) ritualNodo.parentNode.removeChild(ritualNodo);
    ritualNodo = null;
  }

  function ritualConexion() {
    asegurarPersona();
    pintarIdentidad(); // la cabecera ya muestra a la asesora asignada
    var reducido = prefiereMenosMovimiento();

    var caja = crear('div', 'clx-ale-ritual');
    caja.id = 'clx-ale-ritual';
    caja.setAttribute('aria-hidden', 'true');
    var ava = crear('div', 'clx-ale-ritual-ava');
    var av = avatarNodo(null);
    ava.appendChild(av);
    var cuerpo = crear('div', 'clx-ale-ritual-cuerpo');
    var linea = crear('div', 'clx-ale-ritual-linea', 'Buscando a alguien del equipo para ti');
    var sub = crear('div', 'clx-ale-ritual-sub');
    cuerpo.appendChild(linea);
    cuerpo.appendChild(sub);
    caja.appendChild(ava);
    caja.appendChild(cuerpo);
    caja.setAttribute('data-fase', 'buscando');
    el.hilo.appendChild(caja);
    ritualNodo = caja;
    alFinal();

    var MIN = reducido ? 700 : 2000;
    // Este temporizador NO se cancela en quitarRitual: es el mínimo de teatro, y
    // vive aunque el nodo visual se retire (si la red falla antes, nadie lo espera).
    var espera = new Promise(function (res) { setTimeout(res, MIN); });

    var fijar = function () {
      caja.setAttribute('data-fase', 'conectando');
      linea.textContent = 'Conectando con ' + persona.nombre;
      sub.textContent = 'Atención personalizada';
      av.textContent = persona.nombre.charAt(0).toUpperCase();
      av.setAttribute('data-tono', String(persona.tono != null ? persona.tono : 0));
      alFinal();
    };

    if (reducido) { fijar(); return espera; }

    // Fase "buscando": baraja nombres del equipo en el subtítulo y en el disco.
    var barajeo = setInterval(function () {
      var q = PERSONAS[Math.floor(Math.random() * PERSONAS.length)];
      sub.textContent = q.n;
      av.textContent = q.n.charAt(0).toUpperCase();
      av.setAttribute('data-tono', String(q.t));
    }, 190);
    ritualVisualTimers.push(barajeo);

    // A ~1.1 s deja de buscar y "conecta" con la asesora asignada.
    var alConectar = setTimeout(function () {
      clearInterval(barajeo);
      fijar();
    }, 1100);
    ritualVisualTimers.push(alConectar);

    return espera;
  }

  /**
   * Primer contacto: corre el ritual y, en paralelo, pide la bienvenida al motor.
   * El 'hola' va silencioso (no se pinta como burbuja de la clienta). Reusa
   * asegurarSesion/pedir/contexto para conservar el reintento por 401.
   */
  function primerSaludo() {
    enVuelo = true;
    if (el.enviar) el.enviar.disabled = true;

    var espera = ritualConexion();
    var red = asegurarSesion()
      .then(function () { return refrescarCarrito(); })
      .then(function () { return pedir('/mensaje', { texto: 'hola', contexto: contexto() }); })
      .then(function (r) {
        if (r && r.status === 401) {
          sesionId = null;
          guardar(LLAVE_SESION, '');
          return asegurarSesion().then(function () {
            return pedir('/mensaje', { texto: 'hola', contexto: contexto() });
          });
        }
        return r;
      });

    Promise.all([espera, red])
      .then(function (res) {
        quitarRitual();
        pintarRespuesta(res[1]);
      })
      .catch(function () {
        quitarRitual();
        burbuja('aviso', 'No pude conectarme. Revisa tu señal y vuelve a intentar.');
      })
      .then(function () {
        enVuelo = false;
        if (el.enviar) el.enviar.disabled = false;
        if (abierto && esEscritorio()) el.texto.focus();
      });
  }

  // ─── Conversación ─────────────────────────────────────────────────────────

  /**
   * @param {string} texto
   * @param {{silencioso?:boolean}} [opciones] `silencioso` no pinta la burbuja
   *   de la clienta. Se usa para el saludo de apertura: el widget necesita
   *   mandarlo para que el motor abra la conversación, pero pintarlo sería
   *   ponerle en la boca a la clienta algo que ella no escribió.
   */
  function enviar(texto, opciones) {
    texto = (texto || '').trim();
    if (!texto || enVuelo) return;
    if (texto.length > MAX_TEXTO) texto = texto.slice(0, MAX_TEXTO);

    if (!(opciones && opciones.silencioso)) {
      burbuja('clienta', texto);
      // Se persiste YA, no al pintar la respuesta. Si la red falla o la clienta
      // cambia de página antes de que Ale conteste, su pregunta se perdía.
      guardarHilo();
    }
    el.texto.value = '';
    ajustarAlto();
    enVuelo = true;
    el.enviar.disabled = true;
    pensando(true);

    asegurarSesion()
      .then(function () { return pedir('/mensaje', { texto: texto, contexto: contexto() }); })
      .then(function (r) {
        pensando(false);

        // 401: la sesión caducó o se limpió del servidor. Se abre una nueva y se
        // reintenta UNA vez — la clienta no tiene por qué enterarse.
        if (r.status === 401) {
          sesionId = null;
          guardar(LLAVE_SESION, '');
          return asegurarSesion().then(function () {
            return pedir('/mensaje', { texto: texto, contexto: contexto() });
          });
        }
        return r;
      })
      .then(function (r) {
        pensando(false);
        pintarRespuesta(r);
      })
      .catch(function () {
        pensando(false);
        burbuja('aviso', 'No pude conectarme. Revisa tu señal y vuelve a intentar.');
      })
      .then(function () {
        enVuelo = false;
        el.enviar.disabled = false;
        // Igual que al abrir: en móvil devolver el foco reabre el teclado y
        // vuelve a saltar la vista después de CADA mensaje.
        if (abierto && esEscritorio()) el.texto.focus();
      });
  }

  function pintarRespuesta(r) {
    if (!r) return;
    var d = r.datos || {};

    (d.burbujas || []).forEach(function (b) {
      if (b && b.contenido) burbuja('ale', b.contenido);
    });

    if (d.tarjeta) tarjeta(d.tarjeta);
    if (d.tarjetas && d.tarjetas.length) tarjetasProducto(d.tarjetas);
    if (d.acciones && d.acciones.length) acciones(d.acciones);

    // Silencio declarado: el servidor respondió pero sin nada que decir. En
    // WhatsApp eso es "no enviar"; aquí hay una interfaz abierta esperando.
    if (!(d.burbujas || []).length && !d.tarjeta && !(d.tarjetas || []).length) {
      burbuja('aviso', 'Se me cruzaron los cables. ¿Me lo repites?');
    }

    guardarHilo();
    // Si el panel está abierto, lo que acaba de llegar se está viendo: no debe
    // quedar pendiente de leer al navegar a otra página.
    if (abierto) marcarLeido();
  }

  // ─── Persistencia del hilo ────────────────────────────────────────────────
  // Sin esto, la conversación se borra al navegar a otra página del storefront
  // — que es exactamente lo que la clienta hace mientras compra.

  /**
   * Se guarda un HISTORIAL propio en vez de leer el DOM. Antes `guardarHilo()`
   * serializaba solo `.clx-ale-burbuja`, así que al navegar se perdían la
   * tarjeta de producto y las acciones: Ale recomendaba una pieza con su
   * enlace, la clienta iba a verla, volvía — y la recomendación, que es la
   * carga comercial del canal, ya no estaba en el hilo.
   */
  var historial = [];
  var restaurando = false;
  /**
   * Contador que NUNCA se reinicia. La versión anterior comparaba contra
   * `historial.length`, y como el historial se recorta a 40, el contador de
   * leído se clavaba en 40 y `40 > 40` daba falso PARA SIEMPRE: justo la clienta
   * más comprometida —la que sostuvo veinte idas y vueltas— dejaba de enterarse
   * de que Ale respondía. El aviso se moría cuando más valía.
   */
  var secuencia = 0;

  function anotar(entrada) {
    if (restaurando) return;
    entrada.n = ++secuencia;
    historial.push(entrada);
    if (historial.length > 40) historial = historial.slice(-40);
  }

  function guardarHilo() {
    guardar(LLAVE_HILO, JSON.stringify(historial));
  }

  function restaurarHilo() {
    var crudo = leer(LLAVE_HILO);
    if (!crudo) return false;
    try {
      var hilo = JSON.parse(crudo);
      if (!Array.isArray(hilo) || !hilo.length) return false;
      restaurando = true;
      hilo.forEach(function (m) {
        if (m.tipo === 'tarjeta') tarjeta(m.datos);
        else if (m.tipo === 'tarjetas') tarjetasProducto(m.datos);
        else if (m.tipo === 'acciones') acciones(m.datos);
        else burbuja(m.de, m.t);
      });
      restaurando = false;
      historial = hilo;
      // El contador continúa donde quedó. Un hilo guardado por una versión
      // anterior no trae `n`: se le asigna uno para que la cuenta no arranque
      // rota y el aviso quede encendido o apagado de por vida.
      historial.forEach(function (m, i) { if (!m.n) m.n = i + 1; });
      secuencia = historial.length ? historial[historial.length - 1].n : 0;
      return true;
    } catch (e) {
      guardar(LLAVE_HILO, '');
      restaurando = false;
      return false;
    }
  }

  /**
   * El punto de aviso decía "Ale respondió con el panel cerrado", pero se ponía
   * con solo que existiera hilo guardado: aparecía aunque la última palabra
   * fuera de la clienta y aunque ya se hubiera leído, y no se iba nunca. Un
   * aviso que siempre está encendido no avisa de nada — cuando Ale de verdad
   * conteste, ya nadie lo mira. Ahora se cuenta hasta dónde se leyó.
   */
  var LLAVE_LEIDO = 'clx_ale_leido';

  function marcarLeido() {
    var ultimo = historial.length ? historial[historial.length - 1].n : secuencia;
    guardar(LLAVE_LEIDO, String(ultimo || 0));
  }

  function haySinLeer() {
    if (!historial.length) return false;
    var ultimo = historial[historial.length - 1];
    // Solo Ale genera aviso. La clienta ya sabe lo que escribió ella, y un
    // 'aviso' es un ERROR DE RED nuestro: encender el punto dorado por eso le
    // hacía creer que Ale contestó, abría, y se encontraba un fallo de conexión.
    if (ultimo.de !== 'ale') return false;
    return (ultimo.n || 0) > (Number(leer(LLAVE_LEIDO)) || 0);
  }

  // ─── Colisión con el sticky de "Agregar al carrito" ───────────────────────

  /**
   * El PDP tiene una barra fija de compra con z-index 60. El lanzador se sube
   * por encima de ella (z 70) y además se separa de su altura real, medida en
   * vivo: cambia por tema y por tamaño de pantalla, así que codificar un número
   * sería tener el bug a plazos.
   */
  /**
   * ¿Hay algún elemento visible flotando pegado al borde inferior? Devuelve la
   * caja del más alto, o null.
   *
   * Dos cosas que la versión anterior hacía mal y que estos selectores destapan:
   *
   * 1. Usaba `querySelector` (el PRIMERO del DOM). Con varias barras posibles en
   *    la página, la primera podía ser la que está oculta.
   * 2. Solo miraba `bottom`. Las tres barras del tema se esconden con
   *    `transform: translateY(102%)`, no con `display:none`: siguen midiendo, y
   *    su `bottom` queda MÁS ABAJO del borde inferior, así que pasaban la prueba
   *    estando fuera de pantalla. El lanzador se habría separado del borde para
   *    esquivar una barra invisible. Por eso ahora se exige además que el borde
   *    superior esté DENTRO de la ventana.
   */
  function flotaAbajo(sel) {
    var nodos = document.querySelectorAll(sel);
    var alto = window.innerHeight;
    var mejor = null;
    for (var i = 0; i < nodos.length; i++) {
      var n = nodos[i];
      var caja = n.getBoundingClientRect();
      if (caja.height <= 0) continue;
      var est = getComputedStyle(n);
      if (est.display === 'none' || est.visibility === 'hidden' || est.opacity === '0') continue;
      if (caja.top >= alto - 8) continue;           // desplazada fuera por transform
      if (caja.bottom < alto - 8) continue;         // no está pegada abajo
      if (!mejor || caja.height > mejor.height) mejor = caja;
    }
    return mejor;
  }

  /**
   * Las barras fijas REALES del tema, leídas del tema `189572219173` y no
   * inventadas. Las tres son `position:fixed; bottom:0; z-index:60`:
   *   · `.clxp-sticky` — PDP        (`sections/clx-product.liquid:145`)
   *   · `.clxb-sticky` — colección  (`clx-collection.css:315`)
   *   · `.clx-sticky`  — inicio     (`clx-home.css:207`)
   * La lista anterior (`.sticky-atc`, `.product-sticky`, `.product-form__sticky`,
   * `[data-clx-sticky-atc]`) NO existe en ningún archivo del tema: eran nombres
   * genéricos que solo acertaban contra `demo.html`, que yo mismo escribí. Por
   * eso el lanzador tapaba el 84% del botón de comprar en el PDP móvil y el
   * toque de "Agregar" abría el chat.
   * `.clxh-sticky-cta` y `[class*="sticky-atc"]` se conservan porque son los que
   * el propio `clx-wsp.js:70` vigilaba: si él los consideraba reales, aquí no
   * sobran.
   */
  var SEL_STICKY = [
    '.clxp-sticky',
    '.clxb-sticky',
    '.clx-sticky',
    '.clxh-sticky-cta',
    '[class*="sticky-atc"]',
    '[data-clx-sticky-atc]',
  ].join(', ');

  function ajustarOffset() {
    var base = 20;

    // La barra sticky de "Agregar al carrito" (z 60).
    var sticky = flotaAbajo(SEL_STICKY);
    if (sticky) base = sticky.height + 20;

    // El botón de WhatsApp que la tienda YA tenía (`clx-wsp.js`, z 99980, mismo
    // right:16px). Se APILA encima de él en vez de fijar una separación: ese
    // botón se mueve solo cuando detecta la barra sticky, con selectores
    // distintos a los de aquí. Medirlo en vivo es lo único que no se desalinea.
    var wa = flotaAbajo('.clxwa');
    if (wa) base = Math.max(base, window.innerHeight - wa.top + 12);

    // La barra de previsualización de Shopify (`#PBarNextFrameWrapper`), que solo
    // existe al abrir el tema con `preview_theme_id`. Mide 68px pegados abajo y
    // se sienta EXACTAMENTE donde va el lanzador: medido en el sandbox, el
    // lanzador quedaba en y 592-644 y la barra en 596-664, así que un toque real
    // no llegaba nunca al botón — lo tragaba el iframe de Shopify.
    //
    // No es un fallo en producción (ahí la barra no existe), pero SÍ bloquea la
    // única forma que tiene Pedro de probar el widget desde su iPhone antes de
    // publicar. Y es un candidato serio a ser aquel "el botón no funciona" que
    // reportó: entonces lo achacamos entero al botón de WhatsApp enterrado.
    var barraPreview = flotaAbajo('#PBarNextFrameWrapper');
    if (barraPreview) base = Math.max(base, barraPreview.height + 20);

    // Y el PANEL también tiene que subirse, no solo el lanzador. En móvil la
    // hoja va pegada a `bottom:0`, así que su pie —el campo de escribir y el
    // botón de enviar— quedaba ENTERO dentro de la barra de Shopify
    // (medido: campo en 606-652, barra en 596-664) y el toque lo recibía el
    // iframe. La clienta veía la conversación pero no podía escribir.
    //
    // No lo atrapó ninguna comprobación: yo medía que el chat abriera y que el
    // botón de cerrar se viera, nunca que se pudiera ESCRIBIR. Lo vi en una
    // captura, no en un assert.
    document.documentElement.style.setProperty(
      '--clx-ale-fondo', barraPreview ? Math.round(barraPreview.height) + 'px' : '0px');

    document.documentElement.style.setProperty('--clx-ale-offset', Math.round(base) + 'px');
  }

  /**
   * `ajustarOffset` hace `getBoundingClientRect` + `getComputedStyle` sobre
   * varios nodos, y estaba colgado en crudo de `scroll` y `resize`: forzaba un
   * recálculo de layout en cada fotograma del scroll móvil. Se agrupa en un
   * `requestAnimationFrame`, que es exactamente el ritmo al que el resultado
   * puede llegar a verse.
   */
  var pendiente = false;
  function pedirAjuste() {
    if (pendiente) return;
    pendiente = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      pendiente = false;
      ajustarOffset();
    });
  }

  /**
   * Las tres barras del tema no aparecen de golpe: entran con
   * `transition: transform .45s`. Medirlas durante el scroll las agarra a mitad
   * del viaje, y como después del scroll YA NO llega ningún evento, esa medición
   * equivocada se quedaba fija: con la barra puesta el lanzador creía que no
   * había nada (y la tapaba), y con la barra retirada creía que seguía ahí.
   * `transitionend` es el momento exacto en que la geometría es definitiva.
   * El temporizador es el respaldo para cuando la transición no dispara evento
   * (`prefers-reduced-motion`, o la barra que ya estaba en su sitio).
   */
  var asentar = null;
  function pedirAjusteConAsentamiento() {
    pedirAjuste();
    clearTimeout(asentar);
    asentar = setTimeout(ajustarOffset, 520);
  }

  /**
   * `bloquearFondo()` decide por tamaño de pantalla, pero lo decidía UNA sola
   * vez, al abrir. Los dos caminos dinámicos quedaban rotos:
   *   · abrir en una ventana angosta (o en vertical) y luego ensanchar dejaba la
   *     página congelada con el panel ya convertido en tarjeta de esquina — el
   *     mismo defecto de la vuelta 1, alcanzable con un cambio de tamaño; y
   *   · abrir en escritorio y encoger dejaba la hoja inferior sobre una página
   *     que seguía haciendo scroll, con el rebote de iOS que el bloqueo evita.
   * Se re-evalúa en el `resize` que de todos modos ya estaba enganchado.
   */
  function sincronizarBloqueo() {
    if (!abierto) return;
    if (esEscritorio()) {
      if (fondoBloqueado) bloquearFondo(false);
    } else if (!fondoBloqueado) {
      bloquearFondo(true);
    }
  }

  // ─── Tipografía, cargada al abrir ─────────────────────────────────────────

  /**
   * Las MISMAS dos familias que ya usa la tienda, servidas desde sus propios
   * archivos de Shopify (`clx-fraunces.woff2` / `clx-jakarta.woff2`, los que
   * declara `clx-cart-drawer.liquid`). Antes esto pedía Fraunces y Plus Jakarta
   * a Google Fonts, con dos problemas:
   *   · un tercero más en la ruta crítica, teniendo el archivo en casa; y
   *   · las variables solo se fijaban en `link.onload`, así que si el CDN de
   *     Google estaba bloqueado —bastante común— se quedaban SIN DEFINIR y el
   *     panel caía a Georgia + system-ui en silencio. La tipografía ratificada
   *     de la marca desaparecía sin que nada lo dijera.
   * Ahora las variables se fijan de inmediato y el respaldo vive dentro de la
   * propia pila: si el woff2 no carga, el navegador baja a Georgia solo, sin
   * depender de que ningún evento se dispare.
   */
  var CDN_FUENTES = 'https://cdn.shopify.com/s/files/1/0894/1309/1621/files/';

  var fuentesPedidas = false;
  function cargarFuentes() {
    if (fuentesPedidas) return;
    fuentesPedidas = true;

    var estilo = crear('style');
    estilo.textContent =
      "@font-face{font-family:'CLXFraunces';src:url('" + CDN_FUENTES + "clx-fraunces.woff2?v=1783404519') format('woff2');" +
      'font-weight:400 700;font-display:swap}' +
      "@font-face{font-family:'CLXJakarta';src:url('" + CDN_FUENTES + "clx-jakarta.woff2?v=1783404519') format('woff2');" +
      'font-weight:400 700;font-display:swap}';
    document.head.appendChild(estilo);

    var raiz = document.documentElement.style;
    raiz.setProperty('--clx-ale-fuente-titulo', "'CLXFraunces', Georgia, serif");
    raiz.setProperty('--clx-ale-fuente-cuerpo', "'CLXJakarta', system-ui, -apple-system, sans-serif");
  }

  // ─── Apertura y cierre ────────────────────────────────────────────────────

  /**
   * ¿Hay algo de la tienda encima del lanzador ahora mismo?
   *
   * La versión anterior enumeraba UN estado (`clxh-drawer-open`) y por eso
   * dejaba fuera el quick view (z 200) y el lightbox (z 90): tapaban el lanzador
   * al tacto pero lo dejaban ENFOCABLE, así que Tab + Enter abría el chat encima
   * del modal del tema. Enumerar modales es una carrera que se pierde — el tema
   * cambia y la lista se queda vieja.
   *
   * Preguntarle al navegador quién recibe el toque en el centro del botón cubre
   * cualquier capa, la de hoy y la que se agregue mañana, sin conocerla.
   */
  function algoMeTapa() {
    if (document.documentElement.classList.contains('clxh-drawer-open')) {
      // El velo del menú es `pointer-events:none`, así que no aparece en el
      // hit-test: este estado hay que preguntarlo aparte. Se exige además que el
      // drawer EXISTA y se vea, para no quedar muertos si la clase se queda
      // pegada por un fallo del tema.
      var cajon = document.querySelector('.menu-drawer');
      if (cajon && cajon.getBoundingClientRect().width > 0) return true;
    }
    var caja = el.lanzador.getBoundingClientRect();
    if (!caja.width) return false;
    var encima = document.elementFromPoint((caja.left + caja.right) / 2, (caja.top + caja.bottom) / 2);
    return !!(encima && encima !== el.lanzador && !el.lanzador.contains(encima));
  }

  function abrir() {
    // Cinturón además del CSS: el chat no se abre encima de un modal del tema,
    // ni por toque ni por teclado.
    if (algoMeTapa()) return;
    quitarToque(); // si había un bocadillo proactivo, se retira al abrir
    cargarFuentes();
    ajustarOffset();
    abierto = true;
    el.lanzador.hidden = true;
    el.lanzador.setAttribute('aria-expanded', 'true');
    el.lanzador.removeAttribute('data-sin-leer');
    marcarLeido();
    el.velo.hidden = false;
    el.panel.hidden = false;
    el.panel.setAttribute('data-estado', 'entrando');
    // La animación de entrada usa `animation-fill-mode: both`, así que su último
    // fotograma (`transform: translateY(0) scale(1)`) queda aplicado para
    // siempre — y una animación le gana en el cascade a un estilo en línea. Si
    // no se suelta, el `translateY` con el que `seguirTeclado()` sube el panel
    // sobre el teclado de iOS NO tendría ningún efecto.
    setTimeout(function () {
      if (abierto) el.panel.removeAttribute('data-estado');
    }, 360);
    document.documentElement.setAttribute('data-clx-ale-abierto', '1');
    vigilarAvisoDeLaTienda(true);
    bloquearFondo(true);
    // ⚠️ En móvil NO se roba el foco. Enfocar el campo al abrir levanta el
    // teclado de golpe y iOS reacomoda y hace zoom: se siente como si la
    // página saltara sola. La clienta toca el campo cuando quiere escribir.
    if (esEscritorio()) el.texto.focus();
    alFinal();

    if (!el.hilo.children.length) {
      primerSaludo();
    }
  }

  function cerrar() {
    abierto = false;
    bloquearFondo(false);
    vigilarAvisoDeLaTienda(false);
    document.documentElement.removeAttribute('data-clx-ale-abierto');
    marcarLeido();
    el.panel.style.height = '';
    el.panel.style.transform = '';
    el.panel.removeAttribute('data-compacto');
    el.lanzador.setAttribute('aria-expanded', 'false');
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    // El velo se apagaba AQUÍ, de golpe, a mitad de los 200ms de la animación de
    // salida: la hoja terminaba de irse flotando sobre una tienda ya sin
    // oscurecer. Se va con el panel, no antes.
    el.velo.setAttribute('data-estado', 'saliendo');
    el.panel.setAttribute('data-estado', 'saliendo');
    setTimeout(function () {
      // Si en estos 200 ms se volvió a abrir, este temporizador es de una salida
      // que ya no aplica: ocultaría un panel abierto y dejaría al widget
      // creyéndose abierto con todo escondido. Hoy no hay camino de clienta
      // (el lanzador está `hidden` durante la salida), pero lo habrá en cuanto
      // exista una apertura programática — un enlace profundo, o auto-abrir por
      // mensaje sin leer.
      if (abierto) return;
      el.velo.hidden = true;
      el.velo.removeAttribute('data-estado');
      el.panel.hidden = true;
      el.lanzador.hidden = false;
      // El foco vuelve a donde estaba: quien abrió con teclado no queda tirado
      // al principio del documento. Solo en escritorio — en móvil enfocar
      // levanta el teclado, que es justo el salto de vista que se corrigió.
      if (esEscritorio()) el.lanzador.focus();
    }, 200);
  }

  function ajustarAlto() {
    el.texto.style.height = 'auto';
    el.texto.style.height = Math.min(el.texto.scrollHeight, 120) + 'px';
  }

  // ─── Montaje ──────────────────────────────────────────────────────────────

  // La gota REAL de la marca, extraída de `assets/clx-wordmark2.svg` (es la
  // letra E del wordmark). La versión anterior era una gota genérica que yo
  // dibujé: parecida, pero no la de Shilex.
  var GOTA =
    '<svg class="clx-ale-gota" viewBox="0 0 132 280" fill="currentColor" aria-hidden="true">' +
    '<path d="M54.8 3C53.2 4.6 52 6.9 52 8.2C52 9.6 50.5 11.8 48 14C45.2 16.5 44 18.3 44 20.2C44 21.9 43.2 23.3 42 24C40.7 24.7 40 26.1 40 28C40 29.9 39.3 31.3 38 32C36.7 32.7 36 34.1 36 36C36 37.9 35.3 39.3 34 40C32.4 40.8 32 42.1 32 46C32 49.9 31.6 51.2 30 52C28.7 52.7 28 54.1 28 56C28 57.9 27.3 59.3 26 60C24.7 60.7 24 62.1 24 64C24 65.9 23.3 67.3 22 68C20.4 68.8 20 70.1 20 74C20 77.9 19.6 79.2 18 80L16 81.1L16 90L16 98.9L14 100C12.4 100.8 12 102.1 12 106C12 109.9 11.6 111.2 10 112L8 113.1L8 120L8 126.9L6 128L4 129.1L4 138L4 146.9L2 148L0 149.1L0 192L0 234.9L2 236C3.3 236.7 4 238.1 4 240C4 241.9 4.7 243.3 6 244C7.2 244.7 8 246.1 8 247.7C8 249.5 9.3 251.5 11.9 253.9C14.4 256.2 15.9 258.6 16.2 260.5L16.5 263.5L19.5 263.8C21.4 264.1 23.8 265.6 26.1 268.1C28.5 270.7 30.5 272 32.3 272C33.9 272 35.3 272.8 36 274C36.7 275.3 38.1 276 40 276C41.9 276 43.3 276.7 44 278L45.1 280L60 280L74.9 280L76 278C76.8 276.4 78.1 276 82 276C85.9 276 87.2 275.6 88 274C88.7 272.7 90.1 272 92 272C93.9 272 95.3 271.3 96 270C96.6 268.8 98.1 268 99.6 268C103.1 268 116 255.1 116 251.6C116 250.1 116.8 248.6 118 248C119.3 247.3 120 245.9 120 244C120 242.1 120.7 240.7 122 240C123.6 239.2 124 237.9 124 234C124 230.1 124.4 228.8 126 228L128 226.9L128 216L128 205.1L130 204L132 202.9L132 166L132 129.1L130 128L128 126.9L128 112L128 97.1L126 96L124 94.9L124 88L124 81.1L122 80L120 78.9L120 68L120 57.1L118 56C116.7 55.3 116 53.9 116 52C116 50.1 115.3 48.7 114 48C112.4 47.2 112 45.9 112 42C112 38.1 111.6 36.8 110 36C108.7 35.3 108 33.9 108 32C108 30.1 107.3 28.7 106 28C104.7 27.3 104 25.9 104 24C104 22.1 103.3 20.7 102 20C100.8 19.4 100 17.9 100 16.4C100 14.7 97.9 11.9 93 7L86.1 0L71.8 0L57.5 0.1L54.8 3zM81.1 202.9C82.8 204.6 84 206.9 84 208.4C84 209.9 84.8 211.4 86 212C89.8 214 88.5 217.5 80.9 225.2L73.8 232.5L72 230.2C71 229 69.2 228 68 228C65.7 228 60 223.3 60 221.4C60 220.7 60.9 220 62 219.7C63.5 219.3 64 218.3 64 216.1C64 214.1 64.7 212.7 66 212C67.2 211.4 68 209.9 68 208.4C68 205.2 72.8 200.1 75.8 200C77.1 200 79.5 201.3 81.1 202.9z"/></svg>';

  var FLECHA =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M4 12h15m0 0-6-6m6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var EQUIS =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  // ─── Proactividad (#4): un toque, ≤1×/sesión, nunca auto-abre ───────────────
  // Ale ofrece ayuda por su cuenta SOLO ante señales claras, y con un bocadillo
  // descartable sobre el lanzador — nunca abriendo el panel de golpe (el
  // anti-patrón "bandeja de entrada" que el V1 cuidó de evitar). Presupuesto: UNA
  // vez por sesión de navegador (sessionStorage), y jamás si ya está conversando
  // o si ya hay un aviso de "sin leer" pendiente (no se apilan señales).

  function proactivaYaVista() {
    try { return sessionStorage.getItem(LLAVE_PROACTIVA) === '1'; } catch (e) { return false; }
  }
  function marcarProactivaVista() {
    try { sessionStorage.setItem(LLAVE_PROACTIVA, '1'); } catch (e) { /* modo privado */ }
  }

  /** ¿El botón de compra del tema está deshabilitado (variante agotada)?
   *  Defensivo: si el tema no lo expone, devuelve false y el trigger no dispara. */
  function varianteAgotadaEnPagina() {
    if (cfg.pagina !== 'producto') return false;
    var btn = document.querySelector(
      'form[action*="/cart/add"] [name="add"], product-form button[name="add"], .clxp-sticky__btn'
    );
    return !!(btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true'));
  }

  /** El texto del toque, por prioridad de señal. null = sin señal → no molesta. */
  function mensajeProactivo() {
    if (varianteAgotadaEnPagina()) return 'ese tono se agotó — ¿te ayudo a encontrar uno disponible? 💛';
    if (carrito && carrito.length) return '¿alguna duda antes de terminar tu pedido? 💛';
    if (cfg.pagina === 'producto') return '¿te ayudo con algo de este producto? 💛';
    return null;
  }

  /** Muestra el bocadillo sobre el lanzador. NO abre el panel. Descartable. */
  function ofrecerToque(texto) {
    if (proactivaYaVista() || abierto || toqueNodo) return;
    marcarProactivaVista(); // 1×/sesión: se cuenta al mostrarlo, haya o no interacción
    var b = crear('div', 'clx-ale-toque');
    b.setAttribute('role', 'status');
    if (prefiereMenosMovimiento()) b.setAttribute('data-sin-anim', '1');
    b.appendChild(crear('span', 'clx-ale-toque-txt', texto));
    var x = crear('button', 'clx-ale-toque-x');
    x.type = 'button';
    x.setAttribute('aria-label', 'Descartar');
    x.innerHTML = EQUIS;
    x.addEventListener('click', function (e) { e.stopPropagation(); quitarToque(); });
    b.appendChild(x);
    // Tocar el CUERPO del bocadillo abre el chat — pero solo porque la clienta lo
    // tocó. El panel jamás se abre por su cuenta.
    b.addEventListener('click', function () { quitarToque(); abrir(); });
    (el.raiz || document.body).appendChild(b);
    toqueNodo = b;
    // No molesta indefinidamente: se retira solo tras un rato.
    toqueTimers.push(setTimeout(quitarToque, 12000));
  }

  function quitarToque() {
    toqueTimers.forEach(clearTimeout);
    toqueTimers = [];
    if (toqueNodo && toqueNodo.parentNode) toqueNodo.parentNode.removeChild(toqueNodo);
    toqueNodo = null;
  }

  /** Espera un "rato" en la página y, si la clienta no abrió el chat ni hay otra
   *  señal, ofrece el toque. Cancelable si abre el chat antes. El delay es
   *  configurable por `cfg.proactivaMs` (los bancos lo bajan para no esperar). */
  function programarProactividad() {
    if (proactivaYaVista()) return;
    // El delay lo baja el banco WebKit por `window.__clxProactivaMs` (solo test);
    // en producción manda `cfg.proactivaMs` del snippet, o 9 s por defecto.
    var ms = (typeof window.__clxProactivaMs === 'number') ? window.__clxProactivaMs
      : (typeof cfg.proactivaMs === 'number' ? cfg.proactivaMs : 9000);
    toqueTimers.push(setTimeout(function () {
      if (abierto || haySinLeer()) return; // ya conversa o ya hay aviso → no apiles
      // Refrescar el carrito ANTES de decidir: `carrito` arranca en null en cada
      // carga de página y solo se poblaba al abrir el chat, así que el trigger
      // "carrito con algo" nunca disparaba (lo halló el verificador de L3).
      // `refrescarCarrito` siempre resuelve (su catch no relanza).
      refrescarCarrito().then(function () {
        if (abierto || haySinLeer() || proactivaYaVista()) return;
        var msg = mensajeProactivo();
        if (msg) ofrecerToque(msg);
      });
    }, ms));
  }

  function montar() {
    var raiz = crear('div', 'clx-ale');

    // Lanzador
    el.lanzador = crear('button', 'clx-ale-lanzador');
    el.lanzador.type = 'button';
    el.lanzador.setAttribute('aria-label', 'Abrir el chat de atención');
    el.lanzador.setAttribute('aria-expanded', 'false');
    el.lanzador.innerHTML = GOTA + '<span>Escríbenos</span>';
    el.lanzador.addEventListener('click', abrir);

    // El menú de la tienda tiene contraparte en CSS (`opacity:.25`), pero los
    // demás modales —aviso de envío, vista rápida, lightbox, carrito— no tienen
    // ninguna: por dedo daba igual (su velo se come el toque), pero por TECLADO
    // quedaba un botón a plena luz que al pulsarlo no hacía nada. Se evalúa
    // cuando el foco llega, que es justo donde duele, en vez de sondear en bucle.
    // ⚠️ Evaluarlo SOLO en el `focus` dejaba el estado desfasado en las dos
    // direcciones, y las dos ocurren solas:
    //   · el modal se abre cuando el lanzador YA tenía el foco (el aviso de
    //     envío se dispara por temporizador) → quedaba encendido y mudo; y
    //   · el modal se cierra sin que el lanzador pierda el foco → quedaba
    //     `aria-disabled` pegado y al 25%, o sea anunciando "no disponible" un
    //     botón que sí funciona. Ésa es la dirección peor de mentir.
    // Se re-evalúa mientras tenga el foco, que es el único rato en que la señal
    // le sirve a alguien, y se apaga al perderlo.
    var vigilanciaTapado = null;
    var pintarTapado = function () {
      var tapado = algoMeTapa();
      el.lanzador.setAttribute('aria-disabled', tapado ? 'true' : 'false');
      if (tapado) el.lanzador.setAttribute('data-tapado', '1');
      else el.lanzador.removeAttribute('data-tapado');
    };
    el.lanzador.addEventListener('focus', function () {
      pintarTapado();
      clearInterval(vigilanciaTapado);
      vigilanciaTapado = setInterval(pintarTapado, 400);
    });
    el.lanzador.addEventListener('blur', function () {
      clearInterval(vigilanciaTapado);
      vigilanciaTapado = null;
      el.lanzador.removeAttribute('data-tapado');
      el.lanzador.setAttribute('aria-disabled', 'false');
    });

    // Velo. `tabindex="-1"` y `aria-hidden`: la salida por teclado es Escape o el
    // botón de cerrar, y la trampa de foco mantiene el foco DENTRO del panel a
    // propósito. Un velo tabulable metería un destino fantasma en el recorrido y
    // contradiría el `aria-modal`. Para el dedo, en cambio, es la salida
    // natural de una hoja inferior: tocar fuera cierra.
    el.velo = crear('div', 'clx-ale-velo');
    el.velo.hidden = true;
    el.velo.setAttribute('aria-hidden', 'true');
    el.velo.addEventListener('click', cerrar);

    // Panel
    el.panel = crear('div', 'clx-ale-panel');
    el.panel.hidden = true;
    el.panel.setAttribute('role', 'dialog');
    el.panel.setAttribute('aria-modal', 'true');
    el.panel.setAttribute('aria-label', 'Chat con Ale');

    // Si la clienta ya tiene asesora de una visita anterior, se muestra desde el
    // arranque (coherente con su hilo guardado). Si no, queda el neutro de marca
    // hasta que el ritual le asigne una.
    persona = persona || elegirPersonaGuardada();

    var cabecera = crear('div', 'clx-ale-cabecera');
    el.avatar = crear('div', 'clx-ale-cab-avatar');
    var titulos = crear('div', 'clx-ale-cab-textos');
    el.nombre = crear('p', 'clx-ale-nombre');
    el.estado = crear('p', 'clx-ale-estado');
    titulos.appendChild(el.nombre);
    titulos.appendChild(el.estado);
    cabecera.appendChild(el.avatar);
    cabecera.appendChild(titulos);
    pintarIdentidad();

    el.cerrar = crear('button', 'clx-ale-cerrar');
    el.cerrar.type = 'button';
    el.cerrar.setAttribute('aria-label', 'Cerrar el chat');
    el.cerrar.innerHTML = EQUIS;
    el.cerrar.addEventListener('click', cerrar);
    cabecera.appendChild(el.cerrar);

    el.hilo = crear('div', 'clx-ale-hilo');
    // Sin esto, una clienta con lector de pantalla escribe y NO se entera de que
    // le contestaron: las burbujas de Ale se insertan en el DOM sin anunciarse.
    // `polite` y no `assertive` a propósito — no interrumpe lo que esté leyendo.
    el.hilo.setAttribute('role', 'log');
    el.hilo.setAttribute('aria-live', 'polite');
    el.hilo.setAttribute('aria-relevant', 'additions');

    var pie = crear('div', 'clx-ale-pie');
    var forma = crear('form', 'clx-ale-forma');
    forma.addEventListener('submit', function (e) {
      e.preventDefault();
      enviar(el.texto.value);
    });

    el.texto = crear('textarea', 'clx-ale-texto');
    el.texto.rows = 1;
    el.texto.placeholder = 'Escribe tu pregunta…';
    el.texto.setAttribute('aria-label', 'Tu mensaje');
    el.texto.addEventListener('input', ajustarAlto);
    el.texto.addEventListener('keydown', function (e) {
      // Enter envía; Shift+Enter hace salto de línea. En móvil el teclado manda
      // "enter" como salto, así que solo se intercepta con teclado físico.
      if (e.key === 'Enter' && !e.shiftKey && esEscritorio()) {
        e.preventDefault();
        enviar(el.texto.value);
      }
    });

    el.enviar = crear('button', 'clx-ale-enviar');
    el.enviar.type = 'submit';
    el.enviar.setAttribute('aria-label', 'Enviar');
    el.enviar.innerHTML = FLECHA;

    forma.appendChild(el.texto);
    forma.appendChild(el.enviar);
    pie.appendChild(forma);

    el.panel.appendChild(cabecera);
    el.panel.appendChild(el.hilo);
    el.panel.appendChild(pie);

    raiz.appendChild(el.lanzador);
    raiz.appendChild(el.velo);
    raiz.appendChild(el.panel);
    document.body.appendChild(raiz);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && abierto) { cerrar(); return; }
      if (e.key !== 'Tab' || !abierto) return;

      // Trampa de foco. Un `role="dialog" aria-modal="true"` PROMETE que el
      // resto de la página no existe mientras está abierto; sin esto el
      // tabulador se salía al storefront de atrás y, en WebKit, ni siquiera
      // llegaba a Cerrar ni a Enviar. La promesa del atributo hay que cumplirla.
      var foco = el.panel.querySelectorAll(
        'button:not([disabled]), a[href], textarea, input, [tabindex]:not([tabindex="-1"])'
      );
      if (!foco.length) return;

      // El recorrido se hace SIEMPRE a mano, nunca dejando pasar el Tab nativo.
      // En WebKit los botones no entran al orden de tabulación salvo que el
      // usuario active "Acceso completo por teclado": dejar el default hacía que
      // desde el campo de texto el foco saltara FUERA del panel, saltándose el
      // botón de enviar. Moverlo nosotros da el mismo recorrido en todos los
      // motores — y es la única forma de que `aria-modal` no sea una mentira.
      e.preventDefault();
      var lista = Array.prototype.slice.call(foco);
      var i = lista.indexOf(document.activeElement);
      var siguiente = e.shiftKey
        ? (i <= 0 ? lista.length - 1 : i - 1)
        : (i === -1 || i === lista.length - 1 ? 0 : i + 1);
      lista[siguiente].focus();
    });

    // Marca de que el widget montó DE VERDAD. De ella cuelga la regla que
    // esconde el chat de Shopify Inbox: si `clx-ale.js` corta arriba por falta
    // de endpoint, el atributo nunca aparece y la tienda conserva su chat en vez
    // de quedarse sin ninguno.
    document.documentElement.setAttribute('data-clx-ale', '1');

    observarVariante();
    seguirTeclado();
    ajustarOffset();
    window.addEventListener('resize', function () {
      sincronizarBloqueo();
      pedirAjusteConAsentamiento();
    }, { passive: true });
    window.addEventListener('scroll', pedirAjusteConAsentamiento, { passive: true });
    // En captura: `transitionend` no burbujea desde todos los motores por igual.
    document.addEventListener(
      'transitionend',
      function (e) {
        if (e.propertyName === 'transform' && e.target.matches && e.target.matches(SEL_STICKY)) {
          pedirAjuste();
        }
      },
      true
    );

    sesionId = leer(LLAVE_SESION) || null;
    restaurarHilo();
    // Hubo conversación en otra página Y Ale dijo algo que todavía no se lee. Se
    // avisa sin abrir el panel de golpe, que sería el anti-patrón de bandeja de
    // entrada que ya se descartó.
    if (haySinLeer()) el.lanzador.setAttribute('data-sin-leer', '1');

    // Proactividad (#4): tras un rato, un toque descartable si hay señal clara.
    el.raiz = raiz;
    programarProactividad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }
})();
